import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import type { ModelsValue } from "../../../services/api/instances/modelsApi/types";
import {
  createChatComparison,
  createComparisonObjectAction,
  deleteComparisonObjectAction,
  getComparisonObjectsAction,
  getModelsObjectAction,
  updateComparisonObjectAction,
} from "./actions";
import type { ComparisonServiceState } from "./types";

export function getAllComparisonObjectsReducerBuilder(
  builder: ActionReducerMapBuilder<ComparisonServiceState>
) {
  builder.addCase(getComparisonObjectsAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(getComparisonObjectsAction.fulfilled, (state) => {
    state.isLoading = false;
  });
  builder.addCase(getComparisonObjectsAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function createComparisonObjectsReducerBuilder(
  builder: ActionReducerMapBuilder<ComparisonServiceState>
) {
  builder.addCase(createComparisonObjectAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(createComparisonObjectAction.fulfilled, (state, action) => {
    state.comparisonObjects = [...state.comparisonObjects, action.payload];
    state.isLoading = false;
  });
  builder.addCase(createComparisonObjectAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function updateComparisonObjectReducerBuilder(
  builder: ActionReducerMapBuilder<ComparisonServiceState>
) {
  builder.addCase(updateComparisonObjectAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(updateComparisonObjectAction.fulfilled, (state) => {
    state.isLoading = false;
  });
  builder.addCase(updateComparisonObjectAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function deleteComparisonObjectsReducerBuilder(
  builder: ActionReducerMapBuilder<ComparisonServiceState>
) {
  builder.addCase(deleteComparisonObjectAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(deleteComparisonObjectAction.fulfilled, (state) => {
    state.isLoading = false;
  });
  builder.addCase(deleteComparisonObjectAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function getModelsObjectActionReducerBuilder(
  builder: ActionReducerMapBuilder<ComparisonServiceState>
) {
  builder.addCase(getModelsObjectAction.pending, (state) => {
    state.isLoading = true;
  });
  builder.addCase(getModelsObjectAction.fulfilled, (state, action) => {
    state.models = action.payload as ModelsValue;
    state.isLoading = false;
  });
  builder.addCase(getModelsObjectAction.rejected, (state) => {
    state.isLoading = false;
  });
}

export function createChatComparisonReducerBuilder(
  builder: ActionReducerMapBuilder<ComparisonServiceState>
) {
  builder.addCase(createChatComparison.pending, (state, action) => {
    const chatIds = action.meta.arg.map((chat) => chat.id);
    state.comparisonObjectValue = state.comparisonObjectValue.map((chat) =>
      chatIds.includes(chat.id)
        ? { ...chat, isAssistantChatMessageLoading: true }
        : chat
    );
  });

  builder.addCase(createChatComparison.fulfilled, (state, action) => {
    const completedChatId = action.payload.id;
    state.comparisonObjectValue = state.comparisonObjectValue.map((chat) =>
      chat.id === completedChatId
        ? { ...chat, isAssistantChatMessageLoading: false }
        : chat
    );
  });

  builder.addCase(createChatComparison.rejected, (state, action) => {
    const failedChatId = action.meta.arg.find(
      (chat) => chat.id === (action.error as any).id
    )?.id;
    if (failedChatId) {
      state.comparisonObjectValue = state.comparisonObjectValue.map((chat) =>
        chat.id === failedChatId
          ? { ...chat, isAssistantChatMessageLoading: false }
          : chat
      );
    }
  });
}
